import React, { Component } from "react";
import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import { hideLoading, showLoading } from "@my-dld/utils/UIUtils";
import { AppContext } from "@my-dld/contexts/AppContext";
import Strings from "@my-dld/assets/strings";
import { SSOApp } from "../../../../typings/global";
import { LocaleUtil } from "@eres/core";
import { AppConstants } from "../../../configApp";
import { navigate } from "@my-dld/utils/StoreUtils";
import { canRegisterApp, register } from "../../MyDLD/MyApps";
import { UserNotificationHandleNavigation } from "@my-dld/utils/UserNotificationHandler";

interface Prop extends RoutedViewProps<{ appId: string }> {

}

interface State {
	app?: SSOApp;
}

class SSONoApp extends Component<Prop, State> {
	static contextType = AppContext;
	context!: React.ContextType<typeof AppContext>;

	constructor( props: Prop ) {
		super( props );
		const appId = this.props.match.params.appId;
		let app = undefined;
		if ( window.ssoApps )
			app = window.ssoApps.find( x => x.id + "" === appId );
		let ps: Partial<State> = {};

		this.state = {
			app: app,
		};
	}

	setLoading = ( isLoading: boolean ) => {
		if ( isLoading ) {
			showLoading();
		} else hideLoading();
	};


	render() {
		const { app } = this.state;
		const NotificationRedirect = UserNotificationHandleNavigation( this.props.location.pathname );
		if ( NotificationRedirect ) return NotificationRedirect;
		return (
			<React.Fragment>
				<div className="sso-main-container">
					<div className="container">
						<div className="row no-gutters dld-sso-wrapper">
							<div className="dld-sso-grey">
								<div className="dld-sso-white dld-sso-register  py-5 mb-2">
									{ app == null &&
										<span className={ "sso-app-error mb-2" }> <i
											className="fa fa-ban"/> { Strings.no_application_found }</span>
									}
									{ app != null && <div>
										<div className={ "mb-2" }>
                                            <span className={ "sso-app-error " }> <i
	                                            className="fa fa-ban"/> { Strings.no_access_to_app }</span>
										</div>
										<AppItem key={ app.id } app={ app }/>
									</div> }
									<button
										className="btn btn_1 btn-sm mt-2"
										onClick={ this.goToDashBoard }>{ Strings.my_dashboard }</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</React.Fragment>
		);
	}

	goToDashBoard = () => {
		navigate( "/mydld" );
	};
}

function AppItem( props: { app: SSOApp } ) {
	const { app } = props;

	if ( app == null ) return null;
	const name = LocaleUtil.getLocalValue( app.name );
	let iconUrl = LocaleUtil.getLocalValue( { en: app.iconEn, ar: app.iconAr } );
	iconUrl = iconUrl ? iconUrl : app.icon ? LocaleUtil.getLocalValue( app.icon ) : AppConstants.rootUrl + "assets/img/land_department.png";
	const enableReg = canRegisterApp( app );

	const regMe = () => {
		register( app );
	};
	return <div className="d-flex p-30 flex-column justify-content-center align-items-center">
		<div className="sso-app-item-logo">
			<img
				className={ "sso-app-logo sso-app-logo-" + app.id }
				src={ iconUrl } alt="app logo"/>
		</div>
		<div className="sso-app-name">{ name }</div>
		{ enableReg &&
			<button className="btn btn-link btn-sm" onClick={ regMe }>{ Strings.register } <i
				className="fa fa-angle-right"/></button>
		}
	</div>;
}

export default SSONoApp;

